import { Parser } from "@siteimprove/alfa-parser";
import { Token } from "../../syntax/index.js";
import { Numeric } from "./numeric.js";
const { map } = Parser;
/**
 * {@link https://drafts.csswg.org/css-values/#numbers}
 *
 * @public
 */
export class Number extends Numeric {
    static of(value) {
        return new Number(value);
    }
    constructor(value) {
        super(value, "number");
    }
    scale(factor) {
        return new Number(this._value * factor);
    }
    equals(value) {
        return value instanceof Number && super.equals(value);
    }
    toJSON() {
        return super.toJSON();
    }
}
/**
 * @public
 */
(function (Number) {
    function isNumber(value) {
        return value instanceof Number;
    }
    Number.isNumber = isNumber;
    /**
     * {@link https://drafts.csswg.org/css-values/#zero-value}
     */
    Number.parseZero = map(Token.parseNumber((number) => number.value === 0), (number) => Number.of(number.value));
    /**
     * {@link https://drafts.csswg.org/css-values/#number-value}
     */
    Number.parse = map(Token.parseNumber(), (number) => Number.of(number.value));
})(Number || (Number = {}));
//# sourceMappingURL=number.js.map